export default __webpack_public_path__ + "static/media/login_details.8f34eb99.png";